import Vue from 'vue'
import Router from 'vue-router'

// import main components
import LandingPage from '@/components/LandingPage'
import Profiles from '@/components/Profiles'
import Insurances from '@/components/Insurances'
import Results from '@/components/Results'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/profiles',
      name: 'Profiles',
      component: Profiles
    },
    {
      path: '/insurances',
      name: 'Insurances',
      component: Insurances
    },
    {
      path: '/results',
      name: 'Results',
      component: Results
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js